import { render, staticRenderFns } from "./StockCustomers.vue?vue&type=template&id=aa31a1a8&scoped=true"
import script from "./StockCustomers.vue?vue&type=script&lang=js"
export * from "./StockCustomers.vue?vue&type=script&lang=js"
import style0 from "./StockCustomers.vue?vue&type=style&index=0&id=aa31a1a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa31a1a8",
  null
  
)

export default component.exports